import angular from 'angular';
import commissionSummaryWidget from './commissionSummaryWidget';
import waveBg from './waveBg';
import './style.scss';

export default angular
  .module('components.commissionSummaryWidget', [])
  .component('commissionSummaryWidget', commissionSummaryWidget)
  .component('waveBg', waveBg).name;
